type IdentityProps = {
  email: string;
  options?: Record<string, unknown>;
};

type HubspotEventsFunctions = {
  setTrackPageView: () => void;
  setIdentity: (identityProps: IdentityProps) => void;
  trackPage: (path: string) => void;
};

declare global {
  interface Window {
    _hsq?: unknown[];
  }
}

export const useHubspotEvents = (): HubspotEventsFunctions => {
  const _hsq = typeof window !== 'undefined' && window._hsq ? window._hsq : [];

  const setIdentity = ({ email, options }: IdentityProps) => {
    _hsq.push([
      'identify',
      {
        email,
        ...options,
      },
    ]);
  };

  const setTrackPageView = () => {
    _hsq.push(['trackPageView']);
  };

  const trackPage = (path: string): void => {
    _hsq.push(['setPath', path]);

    setTrackPageView();
  };

  return {
    setIdentity,
    setTrackPageView,
    trackPage,
  };
};
